import React from "react";

export default function TermsOfService() {
  return (
    <main className="container">
      <section className="request">
        <h2>Terms of Service</h2>
        <p className="sub">
          Effective date: <strong>December 21, 2025</strong>
        </p>

        <div className="grid-1">
          <h3>1. Overview</h3>
          <p>
            These Terms govern your use of our website and services. By using
            the site, you agree to these Terms.
          </p>

          <h3>2. Services</h3>
          <p>
            We provide facility and related services as described on the site.
            Availability, pricing, and timelines may vary. Quotes may be
            required for final pricing.
          </p>

          <h3>3. Payments</h3>
          <ul>
            <li>Payments may be processed through third-party processors (e.g., PayPal).</li>
            <li>You agree to provide accurate billing information.</li>
          </ul>

          <h3>4. Cancellations and Refunds</h3>
          <p>
            See our <a href="/RefundPolicy">Refund Policy</a> for details.
          </p>

          <h3>5. User Accounts</h3>
          <ul>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>We may require password updates and multi-factor authentication (MFA) for security.</li>
          </ul>

          <h3>6. Prohibited Use</h3>
          <ul>
            <li>Attempting to gain unauthorized access to systems or data.</li>
            <li>Disrupting site functionality or abusing forms and services.</li>
          </ul>

          <h3>7. Disclaimers</h3>
          <p>
            The website and services are provided “as is” to the extent
            permitted by law. We do not guarantee uninterrupted availability or
            error-free operation.
          </p>

          <h3>8. Limitation of Liability</h3>
          <p>
            To the extent permitted by law, AZ Facility Management is not liable
            for indirect, incidental, special, or consequential damages.
          </p>

          <h3>9. Governing Law</h3>
          <p>
            These Terms are governed by the laws of the State of Arizona,
            without regard to conflict of law principles.
          </p>

          <h3>10. Contact</h3>
          <p>
            Questions? Email <strong>service@azfacilitymanagement.com</strong>.
          </p>
        </div>
      </section>
    </main>
  );
}